import React, { useRef } from 'react';
import ReactDOM from "react-dom";
import { map } from "lodash";
import { useStoreState } from "easy-peasy";
import { types } from "../lib/store";
import {useTranslation} from "react-i18next";

function GeneralTitle() {
  const { t } = useTranslation();

  const { name } = useStoreState(state => state.selection.fan);

  /* Reuse same ref on every render
   * https://github.com/facebook/react/issues/15110
   */
  const menuRef = useRef(null);

  if (!menuRef.current) {
    // Create once
    menuRef.current = document.getElementById("fan-general-title");
    menuRef.current.innerHTML = "";
  }

  const domElement = menuRef.current;


  return ReactDOM.createPortal(
    <>
      { name }
    </>
    , domElement
  );
}

export default GeneralTitle;
